import Swiper, {  Pagination } from 'swiper';
Swiper.use([Pagination]);

export default class PageSlider {
	constructor(elm) {
		this.elm = elm;
		this.swiperContainer = this.elm.querySelector('[data-swiper-container]');
		this.pagination = this.elm.querySelector('[data-swiper-pagination]');

		this.swiper = new Swiper(this.swiperContainer, {
			slidesPerView: 1,
			threshold: 2,
			grabCursor: true,
			pagination: {
				el: this.pagination,
				renderBullet: function(index, className) {
					return '<span class="' + className + '">0' + (index + 1) + '</span>';
				},
				clickable: true,
			}
		});
	}

	destroy() {
		if (!this.swiper) {
			return;
		}

		this.swiper.destroy(true, true);
	}
}
